// @FIXME: this needs to blend with the API in a better way, for example this.dm.subscribeToMatch
import update from 'react-addons-update';
import { store, addStorePart, addReducer } from './store';
import { api } from './webapi';

/**
 * Constants
 */
export const dataConst = {
    STORE_PART: 'omfe-core-data:data',

    CREATE_DATA_MANAGER_COMPONENT: 'OMFE_DATA_MANAGER-CREATE_DATA_MANAGER_COMPONENT-ACTION',
    DESTROY_DATA_MANAGER_COMPONENT: 'OMFE_DATA_MANAGER-DESTROY_DATA_MANAGER_COMPONENT-ACTION',

    SUBSCRIPTION_UPDATE: 'OMFE_DATA_MANAGER-SUBSCRIPTION-UPDATE-ACTION',
    SUBSCRIPTION_DELETE: 'OMFE_DATA_MANAGER-SUBSCRIPTION-DELETE-ACTION',
};


/**
 * Store part
 */
addStorePart(dataConst.STORE_PART, {});


/**
 * Reducers
 */

// Creating a new Component
addReducer(dataConst.STORE_PART, dataConst.CREATE_DATA_MANAGER_COMPONENT, (state, action) =>{
    if (!action.uuid){
        return state;
    }
    const newState = Object.assign({}, state);
    newState[action.uuid] = {};
    return newState;
});

// Destroying an existing component
addReducer(dataConst.STORE_PART, dataConst.DESTROY_DATA_MANAGER_COMPONENT, (state, action) =>{
    if (!action.uuid){
        return state;
    }
    const newState = Object.assign({}, state);
    delete newState[action.uuid];
    return newState;
});

// Data Updates
addReducer(dataConst.STORE_PART, dataConst.SUBSCRIPTION_UPDATE, (state, action) =>{
    const {uuid, storeSubPart, isLoaded, data} = action;
    if (!uuid || !storeSubPart || !state[uuid]){
        return state;
    }

    //let newState = Object.assign({}, state); //na
    const newState = Object.assign({}, state); // sm
    newState[uuid] = Object.assign({}, newState[uuid] || {});//sm

    // loading state updates
    newState[uuid].isLoaded = Object.assign({}, newState[uuid].isLoaded || {});//sv
    if (typeof isLoaded !== 'undefined'){
        newState[uuid].isLoaded[storeSubPart] = isLoaded;
    }

    // data updates
    newState[uuid][storeSubPart] = newState[uuid][storeSubPart] || {};
    if (typeof data !== 'undefined'){
        // newState[uuid][storeSubPart] = data && data.version && data.records && Object.assign({}, data.records) || Object.assign({}, data);//sv
        const records = data && data.records || [];
        // newState[uuid][storeSubPart] = {
        //     version: data.version,
        //     records : [...records]
        // };
        newState[uuid][storeSubPart] = records && [...records] || data || {};
        // newState = update(newState, {
        //     [uuid]: {
        //         [storeSubPart]: {
        //             $merge: data && data.version && data.records || data || {},
        //         }
        //     },
        // });
    }

    // @TODO: errors management - when do we delete errors automatically, and based on what

    // done
    return newState;
});

// Data clearing
addReducer(dataConst.STORE_PART, dataConst.SUBSCRIPTION_DELETE, (state, action) =>{
    const {uuid, storeSubPart} = action;
    if (!uuid || !storeSubPart || !state[uuid] || !state[uuid][storeSubPart]){
        return state;
    }
    const newState = Object.assign({}, state);
    newState[uuid] = Object.assign({}, newState[uuid] || {});//sm

    delete newState[uuid][storeSubPart];
    delete newState[uuid].isLoaded[storeSubPart];

    return newState;
});


/**
 * Middlewares-free Data Management Class Around OMFE WebAPI
 * - tracks uuids as individual store parts for components
 * - tracks subscriptions
 * - moves data and errors in the store part for components
 * - keeps loading states in sync with calls/subscriptions
 */
export class DataManager {

    static reservedStoreSubPartNames = {
        isLoaded: true,
        errors: true,
    }

    // Create a new component
    constructor(uuid){
        this.uuid = uuid;
        this.subscriptions = {};

        store.dispatch({type: dataConst.CREATE_DATA_MANAGER_COMPONENT, uuid});
    }

    // Performing subscriptions
    sub(storeSubPart = '', subMethodName = '', params = {}){
        // Reserved store part name
        if (!storeSubPart || DataManager.reservedStoreSubPartNames[storeSubPart]){
            throw new Error(`Invalid storeSubPart supplied, '${storeSubPart}' is reserved`);
        }

        // Store part name already in use
        if (this.subscriptions[storeSubPart]){
            throw new Error(`Invalid storeSubPart supplied, '${storeSubPart}' already exists`);
        }

        // Invalid API method name
        if (!subMethodName || !api[subMethodName]){
            throw new Error(`Invalid subscription method name, no such method '${subMethodName}'`);
        }

        // save 'subscribed' state
        this.subscriptions[storeSubPart] = true;

        // perform subscription
        api[subMethodName]({
            clientRequestId: `${this.uuid}-${storeSubPart}`,
            params,
            onPending: () => store.dispatch({
                type: dataConst.SUBSCRIPTION_UPDATE,
                uuid: this.uuid,
                storeSubPart,
                isLoaded: false,
                data: {}
            }),
            onCompletion: () => store.dispatch({
                type: dataConst.SUBSCRIPTION_UPDATE,
                uuid: this.uuid,
                storeSubPart,
                isLoaded: true
            }),
            onUpdate: (data) => store.dispatch({
                type: dataConst.SUBSCRIPTION_UPDATE,
                uuid: this.uuid,
                storeSubPart,
                data
            }),
            onError: (errors) => store.dispatch({
                type: dataConst.SUBSCRIPTION_UPDATE,
                uuid: this.uuid,
                storeSubPart,
                errors
            }),
        });
    }

    unsub(storeSubPart = '', unsubMethodName = ''){
        // Store part name not already in use
        if (!this.subscriptions[storeSubPart]){
            return false;
        }

        // Invalid API method name
        if (!unsubMethodName || !api[unsubMethodName]){
            throw new Error(`Invalid subscription method name, no such method '${unsubMethodName}'`);
        }

        // delete 'subscribed' state
        delete this.subscriptions[storeSubPart];

        // perform unsubscribe
        api[unsubMethodName](`${this.uuid}-${storeSubPart}`);

        // dispatch deletion action
        return store.dispatch({type: dataConst.SUBSCRIPTION_DELETE, uuid: this.uuid, storeSubPart});
    }

    // Destroying
    done(){
        store.dispatch({type: dataConst.DESTROY_DATA_MANAGER_COMPONENT, uuid: this.uuid});
    }
}



// WEBPACK FOOTER //
// ./src/OMFECore/data-manager.js